<script>
export default {
    name: "PDFViewer",
    props: {
        pdfSrc: {
            type: String,
            default: '',
        },
    },
}
</script>

<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="header">
                    <button class="transparent" type="button" @click="() => $emit('close')">
                        <img
                            class="close-icon"
                            alt="close the PDF viewer"
                            :src="require('@/assets/icon_clear.svg')"
                        />
                    </button>
                </div>
                <div class="body">
                    <iframe class="body__content" :src="`${pdfSrc}#toolbar=1`"></iframe>
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
.large-panel {
    height: 525px;
    display: flex;
    flex-direction: column;
    justify-content: start;
}

.header {
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 5px;
    flex-grow: 0;
    flex-shrink: 0;

    .close-icon {
        height: 40px;
        width: 40px;
    }
}

.body {
    flex-grow: 1;
    flex-shrink: 1;

    .body__content {
        width: 100%;
        height: 100%;
        border: none;
    }
}
</style>
